import React, { useRef } from "react";
import { FileUpload } from "primereact/fileupload";
import { vendor, carrier } from "../assets";
import { Dropdown } from "primereact/dropdown";
import { useFormik } from "formik";
export default function EsnSimBulkUpload({ setAddUnits }) {
  const fileUploadRef = useRef(null);
  function onUpload() {}
  const formik = useFormik({
    initialValues: {
      carrier: "",
      vendor: "",
    },
  });
  return (
    <div>
      <div className="flex flex-column">
        <div className="flex" style={{ gap: "1.2rem" }}>
          <div className="calendar_field">
            <p className="field_label">Carrier</p>
            <Dropdown
              value={formik.values.carrier}
              options={carrier}
              onChange={(e) => formik.setFieldValue("carrier", e.value)}
              placeholder="Select an option"
              className="dropdown"
              style={{
                borderColor:
                  formik.values.carrier === "" ? "#B9BBCC" : "#9C9EB6",
              }}
            />
          </div>
          <div className="calendar_field">
            <p className="field_label">Vendor</p>
            <Dropdown
              value={formik.values.vendor}
              options={vendor}
              onChange={(e) => formik.setFieldValue("vendor", e.value)}
              placeholder="Select an option"
              className="dropdown"
              style={{
                borderColor:
                  formik.values.vendor === "" ? "#B9BBCC" : "#9C9EB6",
              }}
            />
          </div>
        </div>
        <div className="calendar_field">
          <p className="field_label ml-4 mt-2">Upload File</p>
          <FileUpload
            ref={fileUploadRef}
            mode="basic"
            chooseLabel="Choose File"
            uploadLabel="Upload"
            cancelLabel="Cancel"
            multiple
            accept="image/*,application/pdf"
            maxFileSize={1000000}
            onUpload={onUpload}
            className="ml-3"
          />
        </div>
      </div>
      <div className="mt-8">
        <p style={{ fontWeight: "600" }}>
          Please Upload File To Update ESN/SIM's Details Into Inventory
        </p>
      </div>
      <p className="mt-4">
        <span>
          <strong>Header: </strong>(Header Required):
        </span>
        ESN/SIM,Model ID, MSL/PUK, PO#, Box, Notes, Wholesale Price, Selling
        Price, Activation Fee,BYOD (Y/N),MSID , UICCID, Device ID{" "}
        <strong>(Download Sample File)</strong>
      </p>
    </div>
  );
}
